import React, { memo } from "react";
import PropTypes from "prop-types";
import BaseIcon from "../BaseIcon";
import "./style.scss";
import { useTranslation } from "react-i18next";
function BaseLogo({ className, iconLogoStyle, withTitle }) {
  BaseLogo.propTypes = {
    className: PropTypes.string,
    iconLogoStyle: PropTypes.string,
    withTitle: PropTypes.bool,
  };
  const { t } = useTranslation();
  const cls = ["base-logo"];
  const iconLogoCls = [];
  if (className) {
    cls.push(className);
  }
  if (iconLogoStyle) {
    iconLogoCls.push(iconLogoStyle);
  }
  if (withTitle) cls.push("logo-container");
  return (
    <div className={cls.join(" ")}>
      <BaseIcon
        name="intouch_logo"
        iconWrapperStyle="base-logo-wrapper"
        className={`${withTitle && "icon-logo"} ${iconLogoCls.join(" ")}`}
      />
      {withTitle && <div>{t("name_game")}</div>}
    </div>
  );
}

export default memo(BaseLogo);
